export type Locale = "uk" | "en" | "es";

const LOCALE_KEY = "cost-analyzer:locale:v1";

export function normalizeLocale(x: unknown): Locale | null {
  if (x === "uk" || x === "en" || x === "es") return x;
  return null;
}

export function readStoredLocale(): Locale | null {
  try {
    return normalizeLocale(localStorage.getItem(LOCALE_KEY));
  } catch {
    return null;
  }
}

export function writeStoredLocale(locale: Locale): void {
  try {
    localStorage.setItem(LOCALE_KEY, locale);
  } catch {
    /* ignore */
  }
}

export function browserLocaleGuess(): Locale {
  if (typeof navigator === "undefined") return "uk";
  const lang = navigator.language?.toLowerCase() ?? "";
  if (lang.startsWith("uk")) return "uk";
  if (lang.startsWith("es")) return "es";
  return "en";
}

export function numberLocaleFor(locale: Locale): string {
  if (locale === "uk") return "uk-UA";
  if (locale === "es") return "es-ES";
  return "en-US";
}
